const APP_VERSION_KEY = "APP_VERSION";
const RELOAD_GUARD_KEY = "APP_VERSION_RELOADED_FOR";

const setClientAppVersion = (version: string): void => localStorage.setItem(APP_VERSION_KEY, version);

export default defineNuxtPlugin(() => {
  const router = useRouter();
  const {
    public: { APP_VERSION: runningVersion },
  } = useRuntimeConfig();

  router.afterEach(() => {
    fetch("/version.json", { cache: "no-cache" })
      .then((res) => {
        if (!res.ok) return;
        return res.json();
      })
      .then((data?: { version: string }) => {
        const latestVersion = data?.version;
        if (typeof latestVersion !== "string" || !latestVersion) return;
        const reloadedFor = sessionStorage.getItem(RELOAD_GUARD_KEY);

        setClientAppVersion(latestVersion);
        if (runningVersion && runningVersion !== latestVersion && reloadedFor !== latestVersion) {
          sessionStorage.setItem(RELOAD_GUARD_KEY, latestVersion);
          window.location.reload();
        }
      })
      .catch(() => {
        // Silently ignore fetch errors (offline, network issues)
      });
  });
});
